<template>
  <div
    style="
      background-color: black;
      height: 100vh;
      width: 100%;
      display: flex;
      align-items: center;
      justify-content: center;
    "
  >
    <button @click="fetchFolders">Traer Carpetas</button>
    <button @click="fetchVideos">Traer Videos</button>
    <button @click="fetchReelVideos">Traer Reels</button>
  </div>
</template>

<script>
export default {
  data() {
    return {};
  },
  methods: {
    fetchFolders() {
        this.$store.dispatch('getReelFolders')
      console.log("folders");
    },
    fetchVideos() {
      this.$store.dispatch('getVideosByFolder','14417331')
      console.log("videos");
    },
    fetchReelVideos() {
      this.$store.dispatch('getReelVideos')
      
    },
  },
};
</script>
